<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="modalController.dismiss()">
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="start"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" :fullscreen="true">
      <ion-grid fixed class="ion-padding">
        <ion-row>
          <ion-col>
            <div
              class="c-header u-bg-grey"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/icon_roodie_costs.svg') +
                  ')',
              }"
            ></div>
            <p>
              <b>Kostenrückerstattung</b>
            </p>
            <ion-row>
              <ion-col size="auto">
                <ion-icon
                  size="large"
                  :src="require('@lib/assets/icons/money.svg')"
                />
              </ion-col>
              <ion-col>
                Reichen Sie einfach die Rechnung für die Fernbehandlung bei der
                ARAG ein - <arag-app-link />, E-Mail oder Post.
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  modalController,
} from "@ionic/vue";
import AragAppLink from "@/components/AragAppLink";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    AragAppLink,
  },
  data() {
    return {
      modalController: modalController,
    };
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
